document.querySelectorAll('.btn-confirm').forEach(element => {
    element.addEventListener('click', event => {
        if (!confirm(element.dataset.confirmText)) {
            event.preventDefault();
            return false;
        }
    });
});
